<form [formGroup]="form" #formDirective="ngForm" novalidate (ngSubmit)="submit(form.value)">

    <vedrax-controls [descriptor]="descriptor" [form]="form"></vedrax-controls>

    <div class="vedrax-form-footer">
        <button *ngIf="enableCancel" type="button" mat-raised-button (click)="cancel()">{{cancelLabel}}</button>
        <button type="submit" [disabled]="!form.valid || submitted" mat-raised-button
            color="primary">{{submitLabel}}</button>
    </div>

</form>